<template>
  <column-filter-component
    :column-key="columnKey"
    :grid-state="gridState"
    :column-config="columnConfig"
    :filter-types="enumFilterTypes"
  >
    <template #control1="{ value, setValue, columnConfig: slotColumnConfig }">
      <bm-enum-ddl
        clearable
        :value="isEnum(value) ? value : null"
        :enum-type="dropdownEnumType(slotColumnConfig.enumType)"
        @update:value="(event) => setValue(isEnum(event) ? event : '')"
      />
    </template>
    <template #control2="{ value, setValue, columnConfig: slotColumnConfig }">
      <bm-enum-ddl
        clearable
        :value="isEnum(value) ? value : null"
        :enum-type="dropdownEnumType(slotColumnConfig.enumType)"
        @update:value="(event) => setValue(isEnum(event) ? event : '')"
      />
    </template>
  </column-filter-component>
</template>

<script setup lang="ts">
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import BmEnumDdl from "@/components/controls/input/BmEnumDdl.vue";
import type {
  BmGridColumnConfiguration,
  BmGridState,
} from "@/components/controls/grid/BmGridData";
import { enumFilterTypes } from "@/components/controls/grid/columnfilters/EnumColumnFilterApply";
import { isEnum } from "@/app/services/baseEnumType";

defineProps<{
  columnKey: string;
  gridState: BmGridState;
  columnConfig: BmGridColumnConfiguration;
}>();

function dropdownEnumType(enumValues: BmGridColumnConfiguration["enumType"]) {
  return {
    getValues: () => enumValues?.() ?? [],
  };
}
</script>
